import React from "react";
import PropTypes from "prop-types";

import { StyledDropdown } from "./_.styled.js";

const OtherLanguagesDropdown = ({ children, isOpen, onBlur }) => {
  return (
    <StyledDropdown isOpen={isOpen} onBlur={onBlur}>
      {children.map((child) => {
        return <li>{child}</li>;
      })}
    </StyledDropdown>
  );
};

OtherLanguagesDropdown.displayName = "OtherLanguagesDropdown";

OtherLanguagesDropdown.propTypes = {
  /**
   * The contents of the dropdown, typically an Anchor instance or routing navigation component (e.g. React Router 'Link')
   */
  children: PropTypes.node,
  /**
   * Toggles the visibility state of the dropdown – open/closed
   */
  isOpen: PropTypes.bool,
  /**
   * On blur action
   */
  onBlur: PropTypes.func,
};

OtherLanguagesDropdown.defaultProps = {
  isOpen: false,
  justifyRight: false,
};

export default OtherLanguagesDropdown;
